




















import { Vue, Component, Prop } from "vue-property-decorator";
import Button from "@/components/Button.vue";
import SVGIcon from "@/components/SVGIcon.vue";

@Component({
  components: {
    Button,
    SVGIcon,
  },
})
export default class QuantityCounter extends Vue {
  @Prop({ default: 0 }) readonly quantity!: number;
  @Prop({ default: 0 }) readonly min!: number;
  @Prop({ default: 0 }) readonly max!: number;
  @Prop() readonly big!: boolean;

  get _quantity() {
    return this.quantity;
  }

  increment() {
    const quantity = this.quantity + 1
    if (quantity > this.max) return null
    this.$emit("change", { quantity });
  }

  decrement() {
    const quantity = this.quantity - 1
    if (quantity < this.min) return null
    this.$emit("change", { quantity: this.quantity - 1 });
  }
}
